import PropTypes from 'prop-types';
import React, {Component} from 'react';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';
import {has} from 'utils/features';
import AdvertWrapper from "./AdvertWrapper";

require("./GptAdvert.scss");

// Will display GPT on mobile or Standard advert on tablet / desktop
export default class GptAdvert extends Component {
  static propTypes = {
    ocDetails: PropTypes.object,
    performDetails: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      hasOddscheckerIntegration: false,
    };
  }

  componentDidMount() {
    this.setState({
      hasOddscheckerIntegration: has("oddschecker-integration-stage2"),
    });
  }

  render() {
    const {
      ocDetails,
      performDetails
    } = this.props;

    return (
      <div className="gpt-advert">
        <AdvertWrapper {...ocDetails} />
        <GooglePublisherTag {...performDetails}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/GptAdvert.js